/*
 * Chargement du React Course App
 */
import codegen from 'codegen.macro'

codegen`module.exports = require('@mikecodeur/react-course-app/codegen')`
